// The internal tooling panel should be above everything.
export const INTERNAL_TOOLING_PANEL_ZINDEX = 1000;

export const internalToolingPanelCss = {
  position: "fixed",
  right: 0,
  top: 0,
  width: "50vw",
  zIndex: INTERNAL_TOOLING_PANEL_ZINDEX,
  background: "#fff",
  border: "1px dashed black",
  padding: 10,
};
